import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import StudentList from './components/StudentList';
import CreateStudent from './components/CreateStudent';
import StudentDetail from './components/StudentDetail';
import staffApi from '../staffApi';

const Students = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if we're on the create page
  const isCreatePage = location.pathname === '/staff/students/create';

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async (searchParams = {}) => {
    try {
      setLoading(true);
      setError(null);
      const response = await staffApi.getStudents(searchParams);
      if (response.success) {
        setStudents(response.data);
      }
    } catch (err) {
      setError('Failed to fetch students');
      console.error('Error fetching students:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateStudent = async (studentData) => {
    try {
      console.log('Students.js: Creating student with data:', studentData);
      const response = await staffApi.createStudent(studentData);
      console.log('Students.js: Student creation response:', response);
      if (response.success) {
        // Refresh the student list
        await fetchStudents();
        // Navigate back to student list
        navigate('/staff/students');
        return { success: true, message: response.message };
      } else {
        return { success: false, message: response.message || 'Failed to create student' };
      }
    } catch (err) {
      console.error('Error creating student:', err);
      console.error('Error details:', err.response?.data);
      return { success: false, message: err.response?.data?.message || 'Failed to create student' };
    }
  };

  const handleUpdateStudent = async (studentId, studentData) => {
    try {
      const response = await staffApi.updateStudent(studentId, studentData);
      if (response.success) {
        // Refresh the student list
        await fetchStudents();
        return { success: true, message: response.message };
      }
    } catch (err) {
      console.error('Error updating student:', err);
      return { success: false, message: 'Failed to update student' };
    }
  };


  const handleSearch = (searchTerm) => {
    fetchStudents({ search: searchTerm });
  };

  return (
    <div className="space-y-6">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Students Management</h1>
          <p className="mt-2 text-sm text-gray-700">
            Create, view, and manage student information and assignments.
          </p>
        </div>
        {!isCreatePage && (
          <div className="mt-4 sm:mt-0">
            <button
              onClick={() => navigate('/staff/students/create')}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <svg className="-ml-1 mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Add New Student
            </button>
          </div>
        )}
      </div>

      <Routes>
        <Route 
          path="/" 
          element={
            <StudentList 
              students={students}
              loading={loading}
              error={error}
              onSearch={handleSearch}
            />
          } 
        />
        <Route 
          path="/create" 
          element={
            <CreateStudent 
              onCreateStudent={handleCreateStudent}
            />
          } 
        />
        <Route 
          path="/:id" 
          element={
            <StudentDetail 
              onUpdateStudent={handleUpdateStudent}
            />
          } 
        />
      </Routes>
    </div>
  );
};

export default Students;
